import axios from 'axios'
import config from '../config'
//const APPOINTMENT_API_URL = config.appointment_api_url;
const namespaced = true
import { alertController, isPlatform } from "@ionic/vue";


import moment from "moment";


const jose = require('jose')
const secret = new TextEncoder().encode(config.secret_bluedog);
const alg = 'HS256'


import { store } from "@/store/index";

const state = {
    login: { success: false },
    token: '',

    user: {},

}
const actions = {
    GENERATE_JWT: async function ({ state }) {
        let jwt = null;
        let accesstoken = state.user.extra[config.conference] ? state.user.extra[config.conference].tn_accesstoken : null
        let refreshtoken = state.user.extra[config.conference] ? state.user.extra[config.conference].tn_refreshtoken : null
        if (accesstoken) {
            let payload = {
                access_token: accesstoken,
                refresh_token: refreshtoken,
                exp: moment.utc()
            }
            console.log('JWT', payload, config.secret_bluedog)
            jwt = await new jose.SignJWT(payload)
                .setProtectedHeader({ alg })
                .setIssuedAt()
                .setExpirationTime('10m')
                .sign(secret)
            console.log('JWT', jwt)
        }
        return jwt;
    },

    UPDATE_USER_EXTRA: async function ({ commit, state }, payload) {
        let res = await axios.post(config.update_user_extra_url,
            {
                userId: payload.id,
                section: config.conference,
                subsection: null,
                updatefields: [
                    {
                        fieldname: 'consent_given',
                        fieldvalue: payload.consentAnswered
                    }
                ]
            })

        console.log('updated user', res)
    },


    GET_USERDATA: async function ({ commit }) {
        if (localStorage.getItem('x-api-key')) {
            try {
                let res = await axios.get(config.auth_url + 'api/user', {
                    headers: {
                        "x-api-key": localStorage.getItem('x-api-key')
                    }
                })
                return res
            } catch (err) {
                //TODO: hier wird der ganze user zurückgesetzt und ein neuer Login geforced
                console.log('auth', err.response.status)
                if (err && err.response && err.response.status == '403') {
                    localStorage.removeItem('x-api-key');
                    localStorage.removeItem('user')
                    await commit("SET_USER", null);
                }
                return null;
            }

        } else {
            return null;
        }
    },
    DELETE_USERDATA: function () {
        if (localStorage.getItem('x-api-key')) {
            return axios.post(config.auth_url + 'api/user/delete', { "token": localStorage.getItem('x-api-key') }, {
                headers: {
                    "x-api-key": localStorage.getItem('x-api-key')
                }
            })
        } else {
            return null;
        }
    },
    GET_USERACTIVE: function () {
        return axios.get(config.auth_url + 'api/user/active', {
            headers: {
                "x-api-key": localStorage.getItem('x-api-key')
            }
        })
    },
    GET_ROLE: function (payload) {
        return axios.get(config.auth_url + 'api/role/isAllowed/' + payload.role + '/' + payload.conference, {
            headers: {
                "x-api-key": localStorage.getItem('x-api-key')
            }
        })
    },
    GET_LOGIN: function () {
        return this.state.login;
    },
    logout: () => {
        localStorage.removeItem('x-api-key');
        localStorage.removeItem('user');
        window.location.reload()

    },

    GET_APPOINTMENT_ROLE: async function () {
        let userRequest = await store.dispatch("auth/GET_USERDATA");
        let appointmentRoles = { isExhibitor: false, isConsultant: false, exhibitorName: null }

        let exhibitorsArray = await store.dispatch('database/getItems', { table: 'exhibitors' }, { root: true });

        if (exhibitorsArray) {  //if there is exhibitors
            if (userRequest) {

                let filteredData = exhibitorsArray.filter(ex => ex.email == userRequest.data.emailBusiness);  //looks for the exhibitor of this consultant
                let userExhibitor = filteredData[0]//CHANGE THIS AFTER TESTING

                if (userExhibitor && userExhibitor.name != null) {
                    appointmentRoles.isExhibitor = true;
                    appointmentRoles.exhibitorName = userExhibitor.name;
                }
            }
        }

        if (userRequest) {
            let userConsultant = [];//(await axios.post(APPOINTMENT_API_URL + "consultants/getconsultantbyauthuser/"+userRequest.data.id)).data; //gets consultant from user

            if (exhibitorsArray && userConsultant[0]) { //if there is exhibitors
                let exhibitorFromThisConference = exhibitorsArray.filter(ex => ex.id == userConsultant[0].exhibitor_id);  //looks if the consultant exhibitor is in the exhibitor list of this confernece

                if (exhibitorFromThisConference.length > 0) {

                    if (userConsultant) {
                        appointmentRoles.isConsultant = true

                    }
                }
            }
        }


        return appointmentRoles;
    },

    async loginByToken({ commit }, tokenSent) {
        //check for token in path
        let token = tokenSent
        if (token) {
            localStorage.setItem("x-api-key", token);
            let userRequest = await store.dispatch("auth/GET_USERDATA");

            //this.user = userRequest.data;
            let tmpUser = userRequest.data;
            if (tmpUser) {
                await commit("SET_USER", tmpUser);
                let token = await store.dispatch("auth/GENERATE_JWT");
                await commit("SET_TOKEN", token);

                await commit('splashscreen/setShowPassword', false, { root: true })
                localStorage.setItem('user', JSON.stringify(tmpUser));
            }
            //splice the path
            window.history.pushState(
                {},
                document.title,
                '/'
            );
        }
    },

    async login({ dispatch }) {
        console.log("login")
        let self = this
        localStorage.setItem('lastPageBeforeLogin', location.hash);
        //let frontendKey = config.auth_key;
        if (isPlatform('ios') && typeof cordova != 'undefined') {
            let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=no,clearcache=no,clearsessioncache=yes'); // eslint-disable-line

            let redirect = async (param) => {
                if (param && param.indexOf('token=') != -1) {
                    let token = param.split('token=')[1];
                    if (token) {
                        await dispatch('loginByToken', token);
                        ref.close();
                    }
                }
            }

            ref.addEventListener('loaderror', async function (event) {
                ref.executeScript({ code: "document.redirectLink = (document.getElementById('redirect').href);" }, ((link) => {
                    redirect(link.toString());
                }));
                if (event.url.indexOf('token=')) {
                    let token = event.url.split('token=')[1];
                    if (token) {
                        await dispatch('loginByToken', token);
                        ref.close();
                    }
                }
            });
            ref.addEventListener('loadstart', async function (event) {
                console.log('PARAM', event)
                /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
                redirect(link.toString());
              }));*/
                console.log('PARAM', event.url)
                if (event.url.indexOf('token=')) {
                    let token = event.url.split('token=')[1];
                    if (token) {
                        await dispatch('loginByToken', token);
                        ref.close();
                    }
                }
            });


        } else if (isPlatform('android') && typeof cordova != 'undefined') {

            let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=no,clearcache=no,clearsessioncache=yes'); // eslint-disable-line
            ref.addEventListener('loaderror', async function (event) {

                if (event.url.indexOf('token=')) {
                    let token = event.url.split('token=')[1];
                    if (token) {
                        await dispatch('loginByToken', token);
                        ref.close();
                    }
                }
            });
        } else {
            console.log("essta")
            //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
            window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

        }
    }

}
const mutations = {
    SET_USER: (state, user) => {
        if (user) {
            if (user.extra && user.extra[config.conference]) {
                let extra = user.extra[config.conference];
                user.user_tn_role = extra.tn_role;  //cme oder nicht
                user.user_is_chair = extra.is_chair; //nur am mittwoch
                user.user_tn_marker = extra.tn_marker;
                user.user_tn_number = extra.tn_number;//darf ausstellung sehen
                user.user_tn_status = extra.tn_status;//info für chat
                user.user_tn_category = extra.tn_category;
                user.registered = extra.tn_registered;

            }
        }
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
    },
    SET_LOGIN: (state, login) => {
        // Vue.set(state, 'login', login)
        state.login = login
    },
    SET_TOKEN: (state, token) => {
        // Vue.set(state, 'login', login)
        localStorage.setItem('bluedog_jwt', token)
        state.token = token
    },

}
const getters = {
    getLogin: (state) => {
        return state.login;
    },
    user: (state) => {
        return JSON.parse(localStorage.getItem('user', state.user))
    },
    token: (state) => {
        return localStorage.getItem('bluedog_jwt', state.token)
    }
}


export const auth = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
